exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer>div[data-v-70a9ecc0]{max-width:1280px;margin:0 auto}.footer[data-v-70a9ecc0]{background-color:var(--footer-background);font-size:var(--font-size)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70a9ecc0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/mainFooter.vue
// module id = Fvpc
// module chunks = 11 18 32